import { OrderDelivery } from "lib/types/generated/graphql-types"
import CopyButton from "../../../Ui/CopyButton"
import { Info } from "./Operations.styled"
import Money from "../../../Money"
import DineroFactory from "dinero.js"

type Props = {
  delivery: OrderDelivery | undefined
  status: string
  currencyCode: string
  type: string
}

const DeliveryInfo = ({ delivery, status, currencyCode, type }: Props) => {
  if (status === "TRACK_SHIPMENT_SUCCESS" || (status === "MANUAL" && type === "TRACK_SHIPMENT")) {
    const trackingUrl = delivery?.tracking?.url
    return (
      <Info>
        <div>{delivery?.tracking?.reference}</div>
        <div>{delivery?.shippingProvider?.providerName}</div>
        <div>{delivery?.tracking?.shippingCompany}</div>
        <div>{delivery?.tracking?.shippingMethod}</div>
        {trackingUrl && (
          <div>
            <a href={trackingUrl} target={"_blank"}>
              Tracking url
            </a>{" "}
            <CopyButton string={trackingUrl} />
          </div>
        )}
      </Info>
    )
  }

  if (status === "CAPTURE_PAYMENT_SUCCESS" || (status === "MANUAL" && type === "CAPTURE_PAYMENT")) {
    return (
      <Info>
        <b>
         <Money
            amount={delivery?.totals?.grandTotal ?? 0}
            currencyUnit={currencyCode as DineroFactory.Currency}
          />
        </b>
        <div>{delivery?.capturedPayment?.reference}</div>
        <div>{delivery?.paymentProvider?.providerName}</div>
      </Info>
    )
  }
  return null
}

export default DeliveryInfo
